export const FETCH_UNCOMPLETED_SKILLS_SUCCESS = 'FETCH_UNCOMPLETED_SKILLS_SUCCESS';
export const FETCH_UNCOMPLETED_SKILLS_FAILURE= 'FETCH_UNCOMPLETED_SKILLS_FAILURE';
